import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export type TAnnotationColorsIndex =
  | "blue"
  | "green"
  | "pink"
  | "red"
  | "springgreen"
  | "yellow";

export type IAnnotationColors = Record<TAnnotationColorsIndex, string>;

// Used in the annotation card color picker for non-selected colors.
export const annotationColorsLighter: IAnnotationColors = {
  blue: "rgba(133, 183, 253, 0.15)",
  green: "rgba(37, 192, 155, 0.15)",
  pink: "rgba(255, 184, 208, 0.2)",
  red: "rgba(255, 184, 208, 0.2)",
  springgreen: "rgba(37, 192, 155, 0.15)",
  yellow: "rgba(253, 173, 47, 0.15)",
};

// Used as background colors for text highlighting and selected color in the color picker.
export const annotationColors: IAnnotationColors = {
  blue: "rgba(133, 183, 253, 0.25)",
  green: "rgba(37, 192, 155, 0.25)",
  pink: "rgba(255, 184, 208, 0.4)",
  red: "rgba(255, 184, 208, 0.4)",
  springgreen: "rgba(37, 192, 155, 0.25)",
  yellow: "rgba(253, 173, 47, 0.3)",
};

// Used for borders, or the check mark in the color picker.
export const annotationColorsDarker: IAnnotationColors = {
  blue: ui.core[700],
  green: ui.green[500],
  pink: ui.red[500],
  red: ui.red[500],
  springgreen: ui.green[500],
  yellow: ui.yellow[600],
};
